import { DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "../tenantdetails.module.css";
import { ArrowLeft, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const schema = yup.object().shape({
    date: yup.date().required("This field is Required"),
    type: yup.string().required("This field is Required"),
});

const DemandLetterForm = ({ getDemandLetter, setOpenDemandLetterModal }) => {
    const { handleSubmit, control, errors } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        let postData = {};

        if (data.date) {
            postData = { ...postData, date: dayjs(data.date).format("YYYY-MM-DD") };
        }

        postData = { ...postData, type: data.type };

        getDemandLetter(postData);
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenDemandLetterModal(false)}><ArrowLeft /></button>
            <span>Print Demand Letter</span>
            <button onClick={(e) => setOpenDemandLetterModal(false)}><X /></button>
        </DialogTitle>
        <DialogContent>
            <div className={`${styles.ProfileCardEditSec}`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className={`${styles.ProfileEditFormSec} ${styles.ProfileEditFirstSec}`}>
                            <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                <Controller
                                    name="date"
                                    control={control}
                                    render={(field) => (<DatePicker
                                        {...field}
                                        label="Date*"
                                        renderInput={(params) => (<TextField {...params} />)}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />)}
                                />
                                {errors.date && (<p className={`${styles.ErrorM}`}>{errors.date.message}</p>)}
                            </div>
                            <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                                    <Controller
                                        name="type"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Type*"
                                            >
                                                <MenuItem value={'Tenant'}>Tenant Copy</MenuItem>
                                                <MenuItem value={'Landlord'}>Landlord Service Copy</MenuItem>
                                                <MenuItem value={'Both'}>Both</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.type && (<p className={`${styles.ErrorM}`}>{errors.type.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.ButtonArea}`}>
                            <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setOpenDemandLetterModal(false)}>Cancel</button>
                            <button className={`${styles.ButtonVoiletSolid}`} type="submit">Submit</button>
                        </div>
                    </LocalizationProvider>
                </form>
            </div>
        </DialogContent>
    </>)
}


export default DemandLetterForm;